import { Link, useLocation } from "react-router-dom";
import { Home, Search, GitCompare, Award, User } from "lucide-react";
import { useCompare } from "@/context/CompareContext";

const ITEMS = [
  { to: "/", label: "Home", icon: Home },
  { to: "/colleges", label: "Colleges", icon: Search },
  { to: "/rankings", label: "Rankings", icon: Award },
  { to: "/compare", label: "Compare", icon: GitCompare },
  { to: "/dashboard", label: "Account", icon: User },
];

export function MobileNav() {
  const { pathname } = useLocation();
  const { items } = useCompare();
  return (
    <nav data-testid="mobile-bottom-nav" className="lg:hidden fixed bottom-0 inset-x-0 z-40 glass border-t border-black/5">
      <div className="grid grid-cols-5">
        {ITEMS.map(({ to, label, icon: Icon }) => {
          const active = pathname === to;
          return (
            <Link key={to} to={to} className={`flex flex-col items-center gap-0.5 py-2.5 text-[11px] font-medium relative ${active ? "text-gold" : "text-navy/60"}`}>
              <Icon size={19} />
              {label === "Compare" && items.length > 0 && (
                <span className="absolute top-1.5 right-1/2 translate-x-4 bg-gold text-navy-dark text-[9px] font-bold w-4 h-4 rounded-full flex items-center justify-center">{items.length}</span>
              )}
              {label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
